import { create } from 'zustand';
import HalfEdgeMesh from '@/modules/three/common/halfEdgeMesh/HalfEdgeMesh.js';
import { subscribeWithSelector } from 'zustand/middleware';

export type importPhase = 'filePick' | 'rotationFix' | 'upload';

interface ImportScanStoreState {
  upperJawFile: File | null;
  setUpperJawFile: (file: File | null) => void;
  lowerJawFile: File | null;
  setLowerJawFile: (file: File | null) => void;

  upperJawMesh: HalfEdgeMesh | null;
  setUpperJawMesh: (mesh: HalfEdgeMesh | null) => void;
  lowerJawMesh: HalfEdgeMesh | null;
  setLowerJawMesh: (mesh: HalfEdgeMesh | null) => void;

  importPhase: importPhase;
  setImportPhase: (phase: importPhase) => void;

  reset: () => void;
}

const importScanStore = create(
  subscribeWithSelector<ImportScanStoreState>((set) => ({
    upperJawFile: null,
    setUpperJawFile: (file: File | null) => {
      set({ upperJawFile: file });
    },
    lowerJawFile: null,
    setLowerJawFile: (file: File | null) => {
      set({ lowerJawFile: file });
    },

    upperJawMesh: null,
    setUpperJawMesh: (mesh: HalfEdgeMesh | null) => {
      set({ upperJawMesh: mesh });
    },
    lowerJawMesh: null,
    setLowerJawMesh: (mesh: HalfEdgeMesh | null) => {
      set({ lowerJawMesh: mesh });
    },

    importPhase: 'filePick',
    setImportPhase: (phase: importPhase) => {
      set({ importPhase: phase });
    },

    reset: () =>
      set(() => ({
        upperJawFile: null,
        lowerJawFile: null,
        upperJawMesh: null,
        lowerJawMesh: null,
        importPhase: 'filePick',
      })),
  })),
);

export default importScanStore;
